document.querySelectorAll('.hacklabr-posts-grid-block--slider').forEach((container) => {
    const params = JSON.parse(container.querySelector('script').innerHTML);
    const wrapper = container.querySelector('.swiper');
    const swiper = hl_createSwiper(wrapper, {
        ...params,
    });

    const prevBtn = container.querySelector('.swiper-button-prev');
    const nextBtn = container.querySelector('.swiper-button-next');

    [prevBtn, nextBtn].forEach((btn, i) => {
        if (btn && !btn.querySelector('.screen-reader-text')) {
            const srText = document.createElement('span');
            srText.className = 'screen-reader-text';
            srText.textContent = i === 0 ? 'Item anterior' : 'Próximo item';
            btn.insertBefore(srText, btn.firstChild);
        }
    });

    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Carrossel de itens');
});
